module.exports = __webpack_public_path__ + "img/北京冷库2.0a65744e.jpg";